import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { Subject, auditTime, takeUntil, startWith, from } from 'rxjs';

import {
  ConfigService,
  ProductionService,
  StoreService,
  TranslatePipe,
} from '@speedy/core';
import { MatIcon } from '@angular/material/icon';
import { NewsletterComponent } from './newsletter/newsletter.component';
import { BlockComponent } from '../block/block.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [BlockComponent, NewsletterComponent, MatIcon, TranslatePipe, AsyncPipe],
  encapsulation: ViewEncapsulation.None,
})
export class FooterComponent implements AfterViewInit, OnDestroy {
  private readonly configService = inject(ConfigService);
  private readonly productionService = inject(ProductionService);
  private readonly storeService = inject(StoreService);

  private readonly destroy$ = new Subject<void>();
  private readonly storeObservable$ = this.storeService.store$.asObservable();

  isNewsletterActive = !!parseInt(
    this.configService.getConfig('newsletter/general/active') as string,
  );
  copyright: string = this.configService.getConfig('design/footer/copyright');
  showButton = false;

  ngAfterViewInit(): void {
    /**
     * Update click bind when store has been changed and blocks updated.
     */
    from(this.storeObservable$)
      .pipe(startWith(null), auditTime(0), takeUntil(this.destroy$))
      .subscribe(() => {
        this.bindFooterLinkClickEvents();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.scrollY > 200) {
      this.showButton = true;
    } else {
      this.showButton = false;
    }
  }

  bindFooterLinkClickEvents() {
    if (this.productionService.isBrowserMode()) {
      setTimeout(() => {
        const linkBlockTitles = document.querySelectorAll('.footer-links h5');
        linkBlockTitles.forEach((item) => {
          item.addEventListener('click', () => {
            (item as any).nextElementSibling.classList.toggle('open');
          });
        });
      }, 100);
    }
  }

  scrollTop() {
    window.scrollTo(0, 0);
  }
}
